// removed by extract-text-webpack-plugin
module.exports = {"container":"_1PvvXLAEGZFOY8SM60TtUk","inner":"_2Yah8cuHkzh40m2mzOSwvN","as-seen-on":"UrHAgrmDTAkjiKJeBFTNv","row-as-seen-on":"_1ss3w9cr1__OlWd-vdFe1J","as-seen-on-container":"_32nAJ39Zr2uP0sG0fLz99I","half-as-seen-on":"VrvxF4XBDUPKhP-1Wx5jn","as-seen-link":"wBjuzb5vKytx7STTItYjS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/AsSeenOn.scss
// module id = 1167
// module chunks = 47